import t from "../../theme";

export const useGetAppFooterStyles = () => {
  return {
    wrapper: {
      width: "100%",
      padding: "40px 5%",
      display: "flex",
      justifyContent: "center",
      "@media (max-width: 768px)": {
        padding: "24px 16px",
      },
    },
    cardsContainer: {
      display: "flex",
      gap: "24px",
      width: "100%",
      maxWidth: "1200px",
      justifyContent: "center",
      flexWrap: "wrap",
      "@media (max-width: 768px)": {
        flexDirection: "column",
        gap: "16px",
      },
    },
    glassCard: {
      flex: 1,
      minWidth: "260px",
      padding: "28px 24px",
      borderRadius: t.radius.lg,
      background: t.glass.primary,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      border: "1px solid rgba(46, 125, 50, 0.12)",
      boxShadow:
        "0 4px 16px rgba(46, 125, 50, 0.06), 0 1px 3px rgba(0,0,0,0.04)",
      transition: t.transition.smooth,
      "&:hover": {
        background: t.glass.heavy,
        boxShadow:
          "0 8px 24px rgba(46, 125, 50, 0.1), 0 2px 6px rgba(0,0,0,0.06)",
        transform: "translateY(-2px)",
      },
      "@media (max-width: 768px)": {
        minWidth: "unset",
        padding: "20px 18px",
      },
    },
    cardTitle: {
      fontSize: "1.15rem",
      fontWeight: 700,
      color: t.text.primary,
      marginBottom: "16px",
      letterSpacing: "0.3px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    cardSubtitle: {
      fontSize: "0.85rem",
      fontWeight: 600,
      color: t.text.secondary,
      marginBottom: "8px",
    },
    cardText: {
      fontSize: "0.82rem",
      color: t.text.muted,
      lineHeight: 1.6,
      margin: "4px 0",
    },
    iconsContainer: {
      display: "flex",
      gap: "12px",
      marginTop: "8px",
      "& svg": {
        fontSize: "1.4rem",
        color: t.text.secondary,
        padding: "8px",
        borderRadius: t.radius.sm,
        background: "rgba(84, 172, 52, 0.06)",
        border: "1px solid rgba(84, 172, 52, 0.12)",
        cursor: "pointer",
        transition: t.transition.fast,
        width: "36px",
        height: "36px",
        "&:hover": {
          background: "rgba(84, 172, 52, 0.12)",
          color: t.brand.green,
          border: "1px solid rgba(84, 172, 52, 0.25)",
        },
      },
    },
    titleIcon: {
      fontSize: "1.2rem",
      color: t.brand.green,
    },
  };
};
